import { FeatureFlags } from '@icecreamsocial/feature-flags';

const localEnvs = process.env.NODE_ENV === 'local';
const devEnvs = localEnvs || process.env.NODE_ENV === 'development';
const stageEnvs = devEnvs || process.env.NODE_ENV === 'staging';

/**
 * This file contains all features used throughout the app
 * All feature flags must be set here.  They do NOT need to be determined by environment variables
 */
const envFeatureFlags = {
	/**
	 * @date 4/2/23
	 * @description
	 * Enables the new incentive flow
	 * @remove
	 * QA and UAT
	 */
	ENABLE_EXPERIMENTAL_INCENTIVE_FLOW: true,
	/**
	 * @date 3/31/23
	 * @description
	 * Enables the new data and consent collection strategy
	 * @remove
	 * when SMS marketing is supported
	 */
	ENABLE_EXPERIMENTAL_CONSENT_STEP: devEnvs,
	/**
	 * @date 6/22/22
	 * @description
	 * Enables the SMS marketing consent field and whether or not it is required or not
	 * @remove
	 * when SMS marketing is supported
	 */
	ENABLE_EXPERIMENTAL_SMS_CONSENT: false,
};

/**
 * @type {FeatureFlags}
 */
export const flags = new FeatureFlags({
	...envFeatureFlags,
});
